var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTargetIcon = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 26,
  height: 26,
  fill: "none",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#F36805",
  d: "M24.592 11.852h-2.864a8.835 8.835 0 0 0-7.58-7.58V1.408h-2.296v2.864a8.835 8.835 0 0 0-7.58 7.656H1.408v2.297h2.864a8.835 8.835 0 0 0 7.656 7.58v2.863h2.297v-2.94a8.835 8.835 0 0 0 7.503-7.58h2.864zM13 19.508A6.509 6.509 0 1 1 19.508 13 6.523 6.523 0 0 1 13 19.508M15.48 13A2.481 2.481 0 1 1 13 10.52 2.465 2.465 0 0 1 15.48 13"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgTargetIcon);
export default ForwardRef;